/**
 * Where "Login to Dashboard" sends a Juniper client's editors.
 *
 * Unified-dashboard clients go straight to app.heygov.com; every other client
 * goes through the Town Web dashboard login with the site URL + Juniper token.
 *
 * For a client's upgrade copy (the COPY's row as `client`, recognised by its
 * `upgrade_id`, or `target: 'upgrade'` passed explicitly) the HeyGov link
 * carries `?juniper=upgrade`, which the HeyGov dashboard turns into a
 * per-person switch so that person edits the copy instead of the live site.
 * The jurisdiction is the same for both — the copy inherits it from the live
 * client — so it is the parameter, not the slug, that tells them apart. The
 * Town Web dashboard needs no parameter: the copy has its own staging URL.
 *
 * `appUrl` is the client's `heygov_app_url` option (HeyGov instance the site
 * is wired to); app.heygov.com is only the fallback for clients without it.
 */

export const DEFAULT_HEYGOV_APP_URL = 'https://app.heygov.com'

export function heyGovAppUrl(value) {
	const url = String(value || '').trim().replace(/\/+$/, '')
	return url || DEFAULT_HEYGOV_APP_URL
}

export function heyGovJurisdictionSlug(value) {
	if (!value) return ''
	return String(value)
		.trim()
		.replace(/^https?:\/\//, '')
		.replace(/^app\.heygov\.com\//, '')
		.replace(/^\/+|\/+$/g, '')
}

export function buildDashboardLoginUrl(client, { dashboardUrl, email, tokenJuniper, target = 'live', appUrl } = {}) {
	if (!client) return null

	// A row with upgrade_id IS an upgrade copy, whatever the caller said.
	const isUpgradeCopy = target === 'upgrade' || !!client.upgrade_id

	if (client.dashboard === 'unified') {
		const jurisdiction = heyGovJurisdictionSlug(client.heygov_jurisdiction)
		if (jurisdiction) {
			const base = heyGovAppUrl(appUrl || client.heygov_app_url)
			return isUpgradeCopy
				? `${base}/${jurisdiction}/website?juniper=upgrade`
				: `${base}/${jurisdiction}`
		}
	}

	const site = client.staging ? client.staging_url : client.url
	return dashboardUrl + '?url=' + site + '&user=' + (email || '') + '&password=' + tokenJuniper
}
